module.exports = __webpack_public_path__ + "img/appAsset-ui-genericEmail.7567758a.svg";